<template>
  <div id="app">
    <CheckTouch/>
    <router-view/>
  </div>
</template>

<script>
import CheckTouch from '@/components/CheckTouch/CheckTouch.vue'
export default {
  components: {
    CheckTouch
  }
}
</script>


<style lang="scss">
  @import './app.scss';
</style>
